import { ReactElement } from 'react';

import './attachment-pin-icon.styles.scss';

export function AttachmentPinIcon(): ReactElement {
	return (
		<div>
			<svg
				className="attachment-pin-icon"
				width="28"
				height="40"
				viewBox="0 0 28 40"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M28 21.74C28 20.8 27.32 20.04 26.4 19.78C23.86 19.08 22 16.76 22 14V4H24C25.1 4 26 3.1 26 2C26 0.9 25.1 0 24 0H4C2.9 0 2 0.9 2 2C2 3.1 2.9 4 4 4H6V14C6 16.76 4.14 19.08 1.6 19.78C0.68 20.04 0 20.8 0 21.74V22C0 23.1 0.9 24 2 24H11.96L12 38C12 39.1 12.9 40 14 40C15.1 40 16 39.1 16 38L15.96 24H26C27.1 24 28 23.1 28 22V21.74Z"
					fill="#0F37F8"
				/>
			</svg>
		</div>
	);
}
